import React, { useEffect, useMemo, useState } from 'react'
import * as AnalyticsService from '../../services/analytics'
import { useAnalyticsFilters } from '../../contexts/AnalyticsFilterContext'
import AnalyticsPageShell from './components/AnalyticsPageShell'
import { SectionCard, SectionTitle, SimpleTable, TableWrap } from './styles'
import { formatNumber, getAnalyticsErrorMessage } from './utils'

const Events = () => {
    const { rangeFilters } = useAnalyticsFilters()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [data, setData] = useState(null)

    useEffect(() => {
        let cancelled = false

        async function load() {
            setLoading(true)
            setError(null)
            try {
                const response = await AnalyticsService.getEvents(rangeFilters)
                if (!cancelled) setData(response)
            } catch (err) {
                if (!cancelled) setError(getAnalyticsErrorMessage(err))
            } finally {
                if (!cancelled) setLoading(false)
            }
        }

        load()
        return () => {
            cancelled = true
        }
    }, [rangeFilters])

    const groups = useMemo(() => data?.groups || [], [data])

    return (
        <AnalyticsPageShell
            title='Análises de negócio — Eventos (depuração)'
            loading={loading}
            error={error}
            showWorkshopId
        >
            <SectionCard>
                <SectionTitle>Total de eventos no período</SectionTitle>
                <div style={{ fontSize: 28, fontWeight: 700 }}>{formatNumber(data?.totalEvents)}</div>
            </SectionCard>
            <TableWrap>
                {!groups.length ? (
                    <div style={{ padding: 16, color: 'var(--text-tertiary)' }}>Nenhum evento agrupado.</div>
                ) : (
                    <SimpleTable>
                        <thead>
                            <tr>
                                <th>Dia</th>
                                <th>Tipo de evento</th>
                                <th>Ator</th>
                                <th>Origem</th>
                                <th>Quantidade</th>
                            </tr>
                        </thead>
                        <tbody>
                            {groups.map((group, index) => (
                                <tr key={`${group.day}-${group.eventType}-${group.actor}-${group.source}-${index}`}>
                                    <td>{group.day}</td>
                                    <td>{group.eventType}</td>
                                    <td>{group.actor}</td>
                                    <td>{group.source}</td>
                                    <td>{formatNumber(group.count)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </SimpleTable>
                )}
            </TableWrap>
        </AnalyticsPageShell>
    )
}

export default Events
